import(/* webpackMode: "eager" */ "/vercel/path0/src/components/DewiCardList/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/NFTDetails/index.tsx")